import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

/**
 * QuestionWrapper;
 *  - Wrapper for all Question Components
 */
export function QuestionWrapper(props) {
  const className = `${style.wrapper} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

QuestionWrapper.propTypes = {
  /**
   * List of components to display inside this.
   */
  children: PropTypes.array,
  /**
   * ClassName for the question wrapper
   */
  className: PropTypes.string,
};

QuestionWrapper.defaultProps = { className: "", children: null };
